import module from '@babel/traverse/lib/index.js';
          export default module.default ?? module;
          export * from '@babel/traverse/lib/index.js';